import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import CreateGroupListing from '@/modules/manage-member/components/CreateGroup/components/CreateGroupListing'

function CreateGroupPage() {
	return (
		<PageContainer>
			<CreateGroupListing />
		</PageContainer>
	)
}

const GuardedCreateGroupPage = withUserPermission(CreateGroupPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.MANAGE_OPERATOR],
})

export default GuardedCreateGroupPage
